<template>
  <form-filtered-select
    :selected-key="selectedServiceLevel ? selectedServiceLevel.value : null"
    :options="serviceLevelOptions"
    :invalid="invalid"
    placeholder="Service Level"
    @updateDropdownValue="onUpdateValue"
    @close="$emit('close')" />
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedServiceLevel: null
    }
  },
  computed: {
    ...mapState('serviceLevel', ['serviceLevelOptions'])
  },
  watch: {
    value: function () {
      if (this.selectedServiceLevel && this.value.value !== this.selectedServiceLevel.value) {
        this.selectedServiceLevel = this.value
      }
    }
  },
  mounted () {
    this.selectedServiceLevel = this.value
    this.$watch('selectedServiceLevel', function () {
      this.$emit('input', this.selectedServiceLevel)
    })
  },
  methods: {
    onUpdateValue (value) {
      this.selectedServiceLevel = value
    }
  }
}
</script>

<style>

</style>

<style></style>
